import '../vscode-services/missing-services.js';
import { StandaloneServices } from 'monaco-editor/esm/vs/editor/standalone/browser/standaloneServices.js';
import { SyncDescriptor } from 'monaco-editor/esm/vs/platform/instantiation/common/descriptors.js';
import { WorkbenchKeybindingService } from '../vscode/vs/workbench/services/keybinding/browser/keybindingService.js';
import { IKeybindingService } from 'monaco-editor/esm/vs/platform/keybinding/common/keybinding.js';
import { VSBuffer } from 'monaco-editor/esm/vs/base/common/buffer.js';
import { IUserDataProfilesService } from 'monaco-editor/esm/vs/platform/userDataProfile/common/userDataProfile.js';
import { IKeyboardLayoutService } from '../vscode/vs/platform/keyboardLayout/common/keyboardLayout.js';
import { BrowserKeyboardLayoutService } from '../vscode/vs/workbench/services/keybinding/browser/keyboardLayoutService.js';
import { IFileService } from 'monaco-editor/esm/vs/platform/files/common/files.js';
import getServiceOverride$1 from './files.js';
import '../vscode/vs/workbench/browser/workbench.contribution.js';
async function updateUserKeybindings(keybindingsJson) {
    const userDataProfilesService = StandaloneServices.get(IUserDataProfilesService);
    await StandaloneServices.get(IFileService).writeFile(userDataProfilesService.defaultProfile.keybindingsResource, VSBuffer.fromString(keybindingsJson));
}
function getServiceOverride() {
    return {
        ...getServiceOverride$1(),
        [( IKeybindingService.toString())]: new SyncDescriptor(WorkbenchKeybindingService),
        [( IKeyboardLayoutService.toString())]: new SyncDescriptor(BrowserKeyboardLayoutService, undefined, true)
    };
}
export { getServiceOverride as default, updateUserKeybindings };
